module.exports = __webpack_public_path__ + "img/132.66b47d14.jpg";